import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import { ICustomerLocalizationGroup } from 'types';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../../customerFullInfoState/customerFullInfoContext';
import style from './Sidebar.module.scss';

interface ISidebar {
	items: ICustomerLocalizationGroup[];
}

const Sidebar: React.FC<ISidebar> = ({ items }) => {
	const { setLocalizationGroup, selectedLocalizationGroup } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return (
		<>
			{items.length ? (
				<div className={style.container}>
					{items.map((el) => (
						<SidebarItem
							key={el.id}
							label={el.name || ''}
							isActive={selectedLocalizationGroup?.id === el.id}
							onClick={() => setLocalizationGroup(el)}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
